import {
  HighlightableString,
  makeHighlightableString,
} from '@/app/log-viewer/highlighting/HighlightableString';

import {
  LogViewerTableRowModel,
  LogViewerTableRowModelData,
  LogViewerTableRowType,
} from '../../LogViewerTableRowModel';

export interface FileDividerRowModelData extends LogViewerTableRowModelData {
  fileName: HighlightableString;
}

export interface FileDividerRowModel extends LogViewerTableRowModel {
  data: FileDividerRowModelData;
}

export abstract class FileDividerRowModelFactory {
  static make(fileName: string, indexBeforeApplyingFilters: number): FileDividerRowModel {
    const data: FileDividerRowModelData = {
      type: LogViewerTableRowType.FileDivider,
      indexBeforeApplyingFilters,
      indexAfterApplyingFilters: indexBeforeApplyingFilters,
      passesFilter: true,
      isSelected: false,
      isBookmarked: false,
      fileName: makeHighlightableString(fileName),
    };
    return { data };
  }
}
